import { XMarkIcon } from "@heroicons/react/24/solid";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Headline, Label } from "@fronterahealth/frontera-ui-components";

import GoalStatusBadge from "@components/TreatmentPlan/GoalStatusBadge";
import { useClientProgrammingData } from "@providers/ClientProgrammingProvider";

interface ProgrammingGoalHeaderProps {}

export const ProgrammingGoalHeader: React.FC<ProgrammingGoalHeaderProps> = ({}) => {
  const navigate = useNavigate();
  const { clientId } = useParams();
  const { setSelectedGoalId, setSelectedTargetId, selectedGoal, selectedTarget } = useClientProgrammingData();

  const displayName = selectedTarget?.name ?? selectedGoal?.name;
  const displayStatus = selectedTarget?.status ?? selectedGoal?.status;

  const handleClose = () => {
    setSelectedGoalId(null);
    setSelectedTargetId(null);
    navigate(`/clients/${clientId}/programming`);
  };

  const handleGoalClick = () => {
    if (selectedTarget && selectedGoal) {
      navigate(`/clients/${clientId}/programming/goal/${selectedGoal.id}`);
    }
  };

  return (
    <div>
      <div className="flex flex-col gap-2">
        <div className="flex flex-row justify-between items-start gap-2">
          {/* Left side */}
          <div className="flex flex-col">
            {selectedTarget ? (
              <Label
                size="extra-small"
                className="cursor-pointer hover:text-blue-600 transition-colors"
                onClick={handleGoalClick}
              >
                {selectedGoal?.name}
              </Label>
            ) : (
              <Label size="extra-small" className="h-4"></Label>
            )}
            <div className="flex flex-row justify-center items-center align-center gap-x-2">
              <Headline size="medium">{displayName}</Headline>
              {displayStatus && <GoalStatusBadge status={displayStatus} />}
            </div>
          </div>

          {/* Close button */}
          <XMarkIcon className="h-6 w-6 text-text-primary cursor-pointer shrink-0" onClick={handleClose} />
        </div>
      </div>
    </div>
  );
};
